import {Component, Input, OnInit} from '@angular/core';
import {BluechatLoad} from '../../shared/bluechat-load.model';
import {flatten} from '@angular/compiler';
import {BluechatDeliveryWithLoad} from "../../models/BluechatDeliveryWithLoad";

@Component({
  selector: 'app-bluechat-delivery-list',
  templateUrl: './bluechat-delivery-list.component.html',
  styleUrls: ['./bluechat-delivery-list.component.scss']
})
export class BluechatDeliveryListComponent implements OnInit {
  @Input()
  loads: BluechatLoad[];

  deliveriesWithLoad: BluechatDeliveryWithLoad[];

  constructor() { }

  ngOnInit(): void {
    this.deliveriesWithLoad = flatten(this.loads.map(load => {
      return load.deliveries.map(delivery => {
        return {
          delivery,
          load
        }
      })
    }))
  }
}
